import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { firestore } from '../firebase';

import ImagePicker from '../components/Admin/Media/ImagePicker'
import LightboxAlbum from '../components/Public/Lightbox/LightboxAlbum';
import Hero from '../components/View/Hero'
import StateContext from '../StateContext';
import UploadForm from '../components/Admin/Media/UploadForm';
import RemoveImageAlbum from '../components/Admin/Media/RemoveImageAlbum';


function SingleAlbumPage() {
    const {id} = useParams();

    const appState = useContext(StateContext)
    const [album, setAlbum] = useState()
    const [filteredImages, setFilteredImages] = useState([])

    const [show, setShow] = useState(false)

    useEffect(() => {
        try {
            const imagesAlbumRef = firestore.collection("albums").doc(id);
            imagesAlbumRef.onSnapshot(doc => {
                const album = {id: doc.id, ...doc.data()}
                setAlbum(album)
            })
        } catch (error) {
            
        }
    })

    useEffect(() => {

        try {
            const imagesAlbumRef = firestore.collection("albums").doc(id).collection("images");
            imagesAlbumRef.onSnapshot(({docs}) => {
                const images = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                const filteredImages = images.map(image => {
                    return image.imageUrl;
                })
                setFilteredImages(filteredImages)
            })
        } catch (error) {
            console.log(error)
        }

    }, [id])

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    return (
        <React.Fragment>
            <Hero title={album?.title} image={album?.cover_image} subtitle={`Foto: ${album?.photographer}`} />
            {appState.loggedIn &&  (
                <React.Fragment>
                    <div className="text-center">
                        <button className="btn btn-warning" onClick={toggle}>Rediger</button>
                    </div>
                    {show && (
                        <React.Fragment>
                            <h2 className="text-center">Legg til bilder:</h2>
                            <div className="text-center">
                                <ImagePicker type="album" albumId={id} images={filteredImages} />
                            </div>  
         
                            <UploadForm />
                            <br />
                            <br />   
                            <br />
                            <br />   
                            <RemoveImageAlbum albumId={id} />
                        </React.Fragment>
                    )}

                </React.Fragment>
            )}
            
            <div className="container">
                <LightboxAlbum albumImageUrls={filteredImages} />
            </div>
        </React.Fragment>
    )
}
export default SingleAlbumPage